define(["react","underscore","classnames","@bingads-webui-react/i18n-context","@bingads-webui-react/with-default-styles","@bingads-webui-react/primitive","@bingads-webui-universal/accessibility-helper","@bingads-webui/with-state-store","@bingads-webui/state-store"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__117__, __WEBPACK_EXTERNAL_MODULE__163__, __WEBPACK_EXTERNAL_MODULE__867__, __WEBPACK_EXTERNAL_MODULE__870__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 862);
/******/ })
/************************************************************************/
/******/ ({

/***/ 11:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__11__;

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__117__;

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__163__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__36__;

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(863);


/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _src = __webpack_require__(864);

Object.keys(_src).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _src[key];
    }
  });
});

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  notificationStore: true,
  oldAlertCenterAdapter: true,
  OldAlertCenterAdapter: true,
  notificationApi: true,
  actionButtonStyle: true,
  topBannerContentStyle: true
};
Object.defineProperty(exports, "notificationStore", {
  enumerable: true,
  get: function get() {
    return _notificationStore.notificationStore;
  }
});
Object.defineProperty(exports, "oldAlertCenterAdapter", {
  enumerable: true,
  get: function get() {
    return _api.oldAlertCenterAdapter;
  }
});
Object.defineProperty(exports, "OldAlertCenterAdapter", {
  enumerable: true,
  get: function get() {
    return _api.OldAlertCenterAdapter;
  }
});
Object.defineProperty(exports, "notificationApi", {
  enumerable: true,
  get: function get() {
    return _api.notificationApi;
  }
});
Object.defineProperty(exports, "actionButtonStyle", {
  enumerable: true,
  get: function get() {
    return _styles.actionButtonStyle;
  }
});
Object.defineProperty(exports, "topBannerContentStyle", {
  enumerable: true,
  get: function get() {
    return _styles.topBannerContentStyle;
  }
});

var _topBanner = __webpack_require__(865);

Object.keys(_topBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _topBanner[key];
    }
  });
});

var _topBannerLayout = __webpack_require__(875);

Object.keys(_topBannerLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _topBannerLayout[key];
    }
  });
});

var _floatingBanner = __webpack_require__(876);

Object.keys(_floatingBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _floatingBanner[key];
    }
  });
});

var _constants = __webpack_require__(873);

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

var _notificationStore = __webpack_require__(868);

var _api = __webpack_require__(880);

var _styles = __webpack_require__(866);

var _types = __webpack_require__(871);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBannerWithStateStore = exports.TopBanner = exports.UnstyledTopBanner = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _styles = __webpack_require__(866);

var _primitive = __webpack_require__(117);

var _i18nContext = __webpack_require__(17);

var _withDefaultStyles = __webpack_require__(36);

var _accessibilityHelper = __webpack_require__(163);

var _withStateStore = __webpack_require__(867);

var _notificationStore = __webpack_require__(868);

var _buttonWrapper = __webpack_require__(874);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var UnstyledTopBanner =
/** @class */
function (_super) {
  __extends(UnstyledTopBanner, _super);

  function UnstyledTopBanner(props) {
    var _this = _super.call(this, props) || this;

    _this.addIndex = function () {
      if (_this.state.curIndex + 1 >= _this.props.notifications.length) {
        return;
      }

      _this.setState({
        curIndex: _this.state.curIndex + 1
      });
    };

    _this.decIndex = function () {
      if (_this.state.curIndex <= 0) {
        return;
      }

      _this.setState({
        curIndex: _this.state.curIndex - 1
      });
    };

    _this.actionClickHandler = function (action) {
      if (action) {
        action();
      }
    };

    _this.state = {
      curIndex: 0
    };
    return _this;
  }

  UnstyledTopBanner.getDerivedStateFromProps = function (nextProps, prevState) {
    if (prevState.curIndex >= nextProps.notifications.length) {
      return {
        curIndex: 0
      };
    }

    return null;
  };

  UnstyledTopBanner.prototype.render = function () {
    var _this = this;

    var _a;

    var _b = this.props,
        notifications = _b.notifications,
        i18n = _b.i18n,
        classes = _b.classes,
        Wrapper = _b.Wrapper;

    if (notifications.length <= 0) {
      return _react.default.createElement("span", null);
    }

    var curMsg = notifications[this.state.curIndex].message;
    var curNotificationId = notifications[this.state.curIndex].notificationId;
    var indexMsg = i18n.getString(_TL_("{{page}} of {{total}}"), {
      page: this.state.curIndex + 1,
      total: notifications.length
    });
    var canDecrease = this.state.curIndex > 0;
    var decClassNames = "".concat(classes.decButton, " ").concat(canDecrease ? classes.error : classes.invalidButton);
    var canIncrease = this.state.curIndex + 1 < notifications.length;
    var addClassNames = "".concat(classes.addButton, " ").concat(canIncrease ? classes.error : classes.invalidButton);
    return _react.default.createElement("aside", {
      className: (0, _classnames.default)('notification-center-top-banner', classes.topBanner),
      "aria-label": i18n.getString(_TL_("Banner message"))
    }, notifications.length > 1 ? _react.default.createElement("div", {
      className: classes.combination
    }, _react.default.createElement(_primitive.Glyphicon, {
      className: (0, _classnames.default)('notification-center-top-banner-dec-button', decClassNames),
      glyph: 'ba-ChevronLeftMed',
      onClick: this.decIndex,
      role: 'button',
      tabIndex: 0,
      "aria-label": this.props.i18n.getString(_TL_("Previous message")),
      "aria-disabled": !canDecrease,
      onKeyDown: (0, _accessibilityHelper.submitEvent)(this.decIndex)
    }), _react.default.createElement("span", {
      className: (0, _classnames.default)('notification-center-top-banner-index', classes.error)
    }, indexMsg), _react.default.createElement(_primitive.Glyphicon, {
      className: (0, _classnames.default)('notification-center-top-banner-add-button', addClassNames),
      glyph: 'ba-ChevronRightMed',
      onClick: this.addIndex,
      role: 'button',
      tabIndex: 0,
      "aria-label": i18n.getString(_TL_("Next message")),
      "aria-disabled": !canIncrease,
      onKeyDown: (0, _accessibilityHelper.submitEvent)(this.addIndex)
    })) : null, _react.default.createElement(_primitive.Glyphicon, {
      className: classes.errorIcon,
      glyph: 'ba-CriticalErrorSolid'
    }), _react.default.createElement(Wrapper, {
      message: curMsg,
      notificationId: curNotificationId,
      i18n: i18n
    }), (_a = notifications[this.state.curIndex].actionList) === null || _a === void 0 ? void 0 : _a.map(function (action, index) {
      return action.text && _react.default.createElement(_primitive.Button, __assign({
        className: (0, _classnames.default)(classes.actionButton, 'notification-center-top-banner-action', action.extraClassNames),
        onClick: function onClick() {
          return _this.actionClickHandler(action.action);
        },
        key: index
      }, action.extraAttrs), action.text);
    }));
  };

  UnstyledTopBanner.defaultProps = {
    Wrapper: _buttonWrapper.ButtonWrapper
  };
  return UnstyledTopBanner;
}(_react.default.PureComponent);

exports.UnstyledTopBanner = UnstyledTopBanner;
var TopBanner = (0, _i18nContext.withI18nConsumer)((0, _withDefaultStyles.withDefaultStyles)(UnstyledTopBanner, _styles.styles));
exports.TopBanner = TopBanner;
var TopBannerWithStateStore = (0, _withStateStore.withStateStore)(TopBanner, _notificationStore.notificationStore, function (store) {
  var notifications = store.state.bannerNotificationList.map(function (notification) {
    return {
      message: notification.message,
      actionList: notification.actionList
    };
  });
  return {
    notifications: notifications
  };
});
exports.TopBannerWithStateStore = TopBannerWithStateStore;

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonStyle = exports.styles = exports.topBannerContentStyle = exports.actionButtonStyle = void 0;
var actionButtonStyle = {
  color: '#323130',
  height: 24,
  display: 'inline-block',
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '14px',
  padding: '4px 23px',
  marginLeft: '15px',
  background: '#FFFFFF',
  border: '1px solid #C8C6C4',
  boxSizing: 'border-box',
  borderRadius: '2px',
  position: 'relative',
  clear: 'both',
  marginTop: '6px',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: 'rgb(237, 235, 233)'
  }
};
exports.actionButtonStyle = actionButtonStyle;
var topBannerContentStyle = {
  color: '#FFFFFF',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'inline-block',
  verticalAlign: 'top',
  fontSize: 12
};
exports.topBannerContentStyle = topBannerContentStyle;

var styles = function styles(theme) {
  return {
    topBanner: {
      background: '#A80000',
      padding: '0px 10px 0px 8px',
      lineHeight: '36px',
      height: '37px',
      borderBottom: '1px solid #e1dfdd',
      display: 'flex'
    },
    content: topBannerContentStyle,
    errorIcon: {
      color: '#FFFFFF',
      display: 'inline-block',
      paddingLeft: 10,
      paddingRight: 8,
      fontSize: '16px !important',
      flexShrink: 0,
      lineHeight: '36px !important',
      top: '0px !important'
    },
    addButton: {
      padding: 5,
      cursor: 'pointer'
    },
    decButton: {
      padding: 5,
      cursor: 'pointer'
    },
    invalidButton: {
      cursor: 'not-allowed !important',
      color: 'rgba(255,255,255,0.4)',
      fontSize: 12
    },
    error: {
      color: '#FFFFFF',
      fontSize: 12
    },
    combination: {
      display: 'inline-block',
      flexShrink: 0
    },
    actionButton: actionButtonStyle
  };
};

exports.styles = styles;

var buttonStyle = function buttonStyle(theme) {
  return {
    content: {
      color: '#FFFFFF',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inline-block',
      verticalAlign: 'top',
      fontSize: 12
    },
    calloutTargetContainer: {
      flexShrink: 0
    },
    button: actionButtonStyle
  };
};

exports.buttonStyle = buttonStyle;

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__867__;

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "notificationStore", {
  enumerable: true,
  get: function get() {
    return _notificationStore.notificationStore;
  }
});
Object.defineProperty(exports, "NotificationStore", {
  enumerable: true,
  get: function get() {
    return _notificationStore.NotificationStore;
  }
});

var _notificationStore = __webpack_require__(869);

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationStore = exports.NotificationStore = void 0;

var _stateStore = __webpack_require__(870);

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _types = __webpack_require__(871);

var _constants = __webpack_require__(873);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var NotificationStore =
/** @class */
function (_super) {
  __extends(NotificationStore, _super);

  function NotificationStore() {
    var _this = _super.call(this, {
      bannerNotificationList: [],
      nQNotificationList: [],
      floatingBannerNotification: null
    }) || this;

    _this.floatingBannerId = _constants.DefaultFloatingBannerId; // Set default notification data source

    _this.notificationDataSource = {
      getNotifications: function getNotifications() {
        return Promise.resolve([]);
      },
      shouldClearOldNotification: function shouldClearOldNotification() {
        return false;
      },
      shouldShowNewNotification: function shouldShowNewNotification() {
        return true;
      }
    };
    return _this;
  }

  NotificationStore.prototype.setDataSource = function (dataSource) {
    this.notificationDataSource = dataSource;
  };

  NotificationStore.prototype.refresh = function () {
    return __awaiter(this, void 0, void 0, function () {
      var notifications, _a, bannerNotificationList, nQNotificationList, floatingBannerNotification;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , this.notificationDataSource.getNotifications()];

          case 1:
            notifications = _b.sent();
            notifications = notifications.filter(function (notification) {
              return notification.condition == true && _this.notificationDataSource.shouldShowNewNotification(notification);
            });
            _a = this.groupNotifications(notifications), bannerNotificationList = _a.bannerNotificationList, nQNotificationList = _a.nQNotificationList, floatingBannerNotification = _a.floatingBannerNotification; // dispatch notifications here

            this.setState({
              bannerNotificationList: this.mergeToLeft(this.state.bannerNotificationList, bannerNotificationList),
              nQNotificationList: this.mergeToLeft(this.state.nQNotificationList, nQNotificationList),
              floatingBannerNotification: floatingBannerNotification || this.state.floatingBannerNotification
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  }; // TODO: Need to add unit test


  NotificationStore.prototype.mergeToLeft = function (leftList, rightList) {
    var _this = this;

    var rightMap = {};
    var resultList = [];
    rightList.forEach(function (item) {
      rightMap[item.id] = item;
    }); // clear notification that scopeLevel is lower than current change scope

    resultList = leftList.filter(function (notification) {
      if (_this.notificationDataSource.shouldClearOldNotification(notification)) {
        return false;
      }

      return true;
    }); // Replace old one to new one if one notification exists in both new UI and old UI

    resultList = resultList.map(function (item) {
      if (rightMap[item.id]) {
        var newNotification = rightMap[item.id];
        rightMap[item.id] = undefined;
        return newNotification;
      } else {
        return item;
      }
    }); // Add new notification in rightList to result list

    Object.keys(rightMap).forEach(function (key) {
      if (rightMap[key]) {
        resultList.push(rightMap[key]);
      }
    });
    return _underscore.default.assign([], _underscore.default.compact(resultList));
  };

  NotificationStore.prototype.groupNotifications = function (notificationList) {
    var bannerNotificationList = [];
    var nQNotificationList = [];
    var floatingBannerNotification = undefined;
    notificationList.forEach(function (notification) {
      if (notification.target === _types.TargetComponent.TopBanner) {
        bannerNotificationList.push(notification);
      } else if (notification.target === _types.TargetComponent.UnifiedQueue) {
        nQNotificationList.push(notification);
      } else if (notification.target === _types.TargetComponent.FloatingBanner) {
        floatingBannerNotification = notification;
      }
    });
    return {
      bannerNotificationList: bannerNotificationList,
      nQNotificationList: nQNotificationList,
      floatingBannerNotification: floatingBannerNotification
    };
  };
  /**
   * Will be called by Unified Notification Queue
   */


  NotificationStore.prototype.dismissNQAll = function () {
    this.state.nQNotificationList.forEach(function (notification) {
      if (notification.dismissAction) {
        notification.dismissAction(notification);
      }
    });
    this.setState({
      nQNotificationList: []
    });
  };

  NotificationStore.prototype.buildDimissAction = function (notification) {
    var _this = this;

    if (_types.DismissMode.never) {
      var originDismissAction_1 = notification.dismissAction;

      notification.dismissAction = function () {
        _this.deleteNotificationFromList(notification.id);

        if (originDismissAction_1) {
          originDismissAction_1(notification);
        }
      };
    }

    switch (notification.dismissMode) {
      case _types.DismissMode.session:
      case _types.DismissMode.custom:
      case _types.DismissMode.once:
      case _types.DismissMode.permanent:
        var originDismissAction_2 = notification.dismissAction;

        notification.dismissAction = function () {
          _this.deleteNotificationFromList(notification.id);

          if (originDismissAction_2) {
            originDismissAction_2(notification);
          }
        };

        break;

      case _types.DismissMode.never:
      default:
        break;
    }
  };

  NotificationStore.prototype.deleteNotificationFromList = function (id) {
    var bannerNotificationList = this.state.bannerNotificationList.filter(function (n) {
      return n.id !== id;
    });
    var nQNotificationList = this.state.nQNotificationList.filter(function (n) {
      return n.id !== id;
    });
    this.setState({
      bannerNotificationList: bannerNotificationList,
      nQNotificationList: nQNotificationList
    });
  }; // used by notification api to remove all from external


  NotificationStore.prototype.removeAllTopBanners = function () {
    this.setState({
      bannerNotificationList: []
    });
  }; // used by notification api to add notification


  NotificationStore.prototype.add = function (notification) {
    if (notification.target === _types.TargetComponent.TopBanner) {
      var bannerNotificationList = this.state.bannerNotificationList.filter(function (n) {
        return n.id !== notification.id;
      });
      bannerNotificationList.push(notification);
      this.setState({
        bannerNotificationList: bannerNotificationList
      });
    } else if (notification.target === _types.TargetComponent.UnifiedQueue) {
      var nQNotificationList = this.state.nQNotificationList.filter(function (n) {
        return n.id !== notification.id;
      });
      nQNotificationList.unshift(notification); // insert at the start of array

      this.setState({
        nQNotificationList: nQNotificationList
      });
    } else if (notification.target === _types.TargetComponent.FloatingBanner) {
      if (notification.severity === _types.NotificationLevel.Info || notification.severity === _types.NotificationLevel.Confirmation) {
        this.setFloatingBannerNotification(notification.message, _types.NotificationLevel.Info);
      } else {
        this.setFloatingBannerNotification(notification.message, _types.NotificationLevel.Warning);
      }

      return this.floatingBannerId;
    }

    return notification.id;
  }; // used by notification api


  NotificationStore.prototype.setFloatingBannerNotification = function (message, severity, extraOptions) {
    var notification = {
      message: message,
      title: '',
      severity: severity,
      id: this.floatingBannerId,
      target: _types.TargetComponent.FloatingBanner,
      condition: true,
      extraOptions: extraOptions
    };
    this.setState({
      floatingBannerNotification: notification
    });
    return this.floatingBannerId;
  }; // used by notification api to dismiss notification


  NotificationStore.prototype.dismiss = function (id) {
    if (id === this.floatingBannerId) {
      this.setState({
        floatingBannerNotification: undefined
      });
    } else {
      this.deleteNotificationFromList(id);
    }
  };

  return NotificationStore;
}(_stateStore.StateStore);

exports.NotificationStore = NotificationStore;
var notificationStore = new NotificationStore(); //Add to window for easier debugging

exports.notificationStore = notificationStore;
window.notificationStore = notificationStore;

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__870__;

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification = __webpack_require__(872);

Object.keys(_notification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _notification[key];
    }
  });
});

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScopeLevel = exports.DismissMode = exports.NotificationLevel = exports.TargetComponent = void 0;

/** ************************ Core Interface Start ****************************** */
var TargetComponent;
exports.TargetComponent = TargetComponent;

(function (TargetComponent) {
  TargetComponent["TopBanner"] = "TopBanner";
  TargetComponent["UnifiedQueue"] = "UnifiedQueue";
  TargetComponent["FloatingBanner"] = "FloatingBanner";
})(TargetComponent || (exports.TargetComponent = TargetComponent = {}));

var NotificationLevel;
exports.NotificationLevel = NotificationLevel;

(function (NotificationLevel) {
  NotificationLevel["Error"] = "Error";
  NotificationLevel["Info"] = "Information";
  NotificationLevel["Warning"] = "Warning";
  NotificationLevel["Critical"] = "Critical";
  NotificationLevel["Confirmation"] = "Confirmation";
})(NotificationLevel || (exports.NotificationLevel = NotificationLevel = {}));

var DismissMode;
exports.DismissMode = DismissMode;

(function (DismissMode) {
  DismissMode["permanent"] = "permanent";
  DismissMode["session"] = "session";
  DismissMode["never"] = "never";
  DismissMode["once"] = "once";
  DismissMode["custom"] = "custom";
})(DismissMode || (exports.DismissMode = DismissMode = {}));

var ScopeLevel;
exports.ScopeLevel = ScopeLevel;

(function (ScopeLevel) {
  ScopeLevel[ScopeLevel["root"] = 16] = "root";
  ScopeLevel[ScopeLevel["customer"] = 8] = "customer";
  ScopeLevel[ScopeLevel["account"] = 4] = "account";
  ScopeLevel[ScopeLevel["campaign"] = 2] = "campaign";
  ScopeLevel[ScopeLevel["adGroup"] = 1] = "adGroup";
})(ScopeLevel || (exports.ScopeLevel = ScopeLevel = {}));

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultFloatingBannerId = void 0;
var DefaultFloatingBannerId = 'floatingBannerId';
exports.DefaultFloatingBannerId = DefaultFloatingBannerId;

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonWrapper = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _styles = __webpack_require__(866);

var _withDefaultStyles = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

// This is to split server-side returned <a> element in message and convert to button style
var unstyledButtonWrapper =
/** @class */
function (_super) {
  __extends(unstyledButtonWrapper, _super);

  function unstyledButtonWrapper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  unstyledButtonWrapper.prototype.render = function () {
    var classes = this.props.classes;
    var doc = new DOMParser().parseFromString(this.props.message, 'text/html');
    var aElements = doc.body.getElementsByTagName('a');

    if (aElements.length <= 0) {
      return _react.default.createElement("span", {
        className: (0, _classnames.default)('notification-center-top-banner-message', classes.content),
        title: doc.body.innerText,
        dangerouslySetInnerHTML: {
          __html: doc.body.innerHTML
        }
      });
    } else {
      var aTags = Array.prototype.slice.call(aElements).map(function (el) {
        var aTag = doc.body.removeChild(el);
        aTag.classList.add(classes.button);

        if (!aTag.style.color) {
          aTag.style.color = 'black';
        }

        return aTag.outerHTML;
      }).join('');
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", {
        className: (0, _classnames.default)('notification-center-top-banner-message', classes.content)
      }, doc.body.innerHTML), _react.default.createElement("span", {
        className: (0, _classnames.default)('notification-center-top-banner-action', classes.calloutTargetContainer),
        dangerouslySetInnerHTML: {
          __html: aTags
        }
      }));
    }
  };

  return unstyledButtonWrapper;
}(_react.default.PureComponent);

var ButtonWrapper = (0, _withDefaultStyles.withDefaultStyles)(unstyledButtonWrapper, _styles.buttonStyle);
exports.ButtonWrapper = ButtonWrapper;

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBannerLayout = exports.getTopBannerLayoutWithStore = void 0;

var _topBanner = __webpack_require__(865);

var _react = _interopRequireDefault(__webpack_require__(3));

var _notificationStore = __webpack_require__(868);

var _withStateStore = __webpack_require__(867);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/* istanbul ignore file */


var TopBannerLayoutInternal =
/** @class */
function (_super) {
  __extends(TopBannerLayoutInternal, _super);

  function TopBannerLayoutInternal(props) {
    return _super.call(this, props) || this;
  }

  TopBannerLayoutInternal.prototype.componentDidMount = function () {
    this.decideShowBanner();
  };

  TopBannerLayoutInternal.prototype.componentDidUpdate = function () {
    this.decideShowBanner();
  };

  TopBannerLayoutInternal.prototype.render = function () {
    var notifications = this.props.bannerNotificationList.map(function (notification) {
      return {
        notificationId: notification.id,
        message: notification.message,
        actionList: notification.actionList
      };
    });
    return _react.default.createElement(_topBanner.TopBanner, {
      notifications: notifications,
      Wrapper: this.props.Wrapper
    });
  };

  TopBannerLayoutInternal.prototype.showTopBanner = function () {
    this.props.changeLayout({
      topBanner: {
        mode: 'expanded'
      }
    }, false, false, this.props.afterChangeLayout);
  };

  TopBannerLayoutInternal.prototype.hideTopBanner = function () {
    this.props.changeLayout({
      topBanner: {
        mode: 'collapsed'
      }
    });
  };

  TopBannerLayoutInternal.prototype.decideShowBanner = function () {
    // If top banner is in hidden mode, we will never show it.
    var isHiddenMode = this.props.mode === 'hidden';

    if (isHiddenMode) {
      return;
    }

    if (this.props.bannerNotificationList.length !== 0) {
      this.showTopBanner();
    } else {
      this.hideTopBanner();
    }
  };

  return TopBannerLayoutInternal;
}(_react.default.PureComponent);

var getTopBannerLayoutWithStore = function getTopBannerLayoutWithStore(customizedStore, Wrapper) {
  return (0, _withStateStore.withStateStore)(TopBannerLayoutInternal, customizedStore, function (store) {
    return {
      bannerNotificationList: store.state.bannerNotificationList,
      Wrapper: Wrapper
    };
  });
};

exports.getTopBannerLayoutWithStore = getTopBannerLayoutWithStore;
var TopBannerLayout = getTopBannerLayoutWithStore(_notificationStore.notificationStore);
exports.TopBannerLayout = TopBannerLayout;

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _floatingBanner = __webpack_require__(877);

Object.keys(_floatingBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _floatingBanner[key];
    }
  });
});

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrappedFloatingBannerContainer = exports.getWrappedFloatingBannerContainer = exports.FloatingBanner = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _notificationStore = __webpack_require__(868);

var _i18nContext = __webpack_require__(17);

var _withStateStore = __webpack_require__(867);

var _floatingBannerBar = __webpack_require__(878);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var FloatingBanner =
/** @class */
function (_super) {
  __extends(FloatingBanner, _super);

  function FloatingBanner() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.timeoutID = -1;

    _this.dismiss = function () {
      if (_this.timeoutID >= 0) {
        window.clearTimeout(_this.timeoutID);
      }

      _this.timeoutID = -1;

      _this.props.clearNotification();
    };

    return _this;
  }

  FloatingBanner.prototype.render = function () {
    if (!this.props.floatingBannerNotification) {
      return null;
    } else {
      return _react.default.createElement(_floatingBannerBar.FloatingBannerBar, {
        notification: this.props.floatingBannerNotification,
        i18n: this.props.i18n,
        Wrapper: this.props.Wrapper,
        dismiss: this.dismiss
      });
    }
  };

  FloatingBanner.prototype.componentDidMount = function () {
    if (this.props.floatingBannerNotification) {
      this.startDismiss();
    }
  };

  FloatingBanner.prototype.componentDidUpdate = function () {
    if (this.props.floatingBannerNotification) {
      this.startDismiss();
    }
  };

  FloatingBanner.prototype.startDismiss = function () {
    var _this = this;

    var _a, _b;

    if (this.timeoutID >= 0) {
      window.clearTimeout(this.timeoutID);
    }

    var autoDismissTime = (_b = (_a = this.props.floatingBannerNotification) === null || _a === void 0 ? void 0 : _a.extraOptions) === null || _b === void 0 ? void 0 : _b.autoDismissTime;

    if (autoDismissTime && autoDismissTime > 0) {
      this.timeoutID = window.setTimeout(function () {
        _this.timeoutID = -1;

        _this.props.clearNotification();
      }, autoDismissTime);
    }
  };

  return FloatingBanner;
}(_react.default.PureComponent);

exports.FloatingBanner = FloatingBanner;

// floating banner is always action-triggered, so we use the store in shared repo to avoid creating two containers in app
var getWrappedFloatingBannerContainer = function getWrappedFloatingBannerContainer(Wrapper) {
  return (0, _withStateStore.withStateStore)((0, _i18nContext.withI18nConsumer)(FloatingBanner), _notificationStore.notificationStore, function (store) {
    return {
      floatingBannerNotification: store.state.floatingBannerNotification,
      Wrapper: Wrapper,
      clearNotification: function clearNotification() {
        store.setState({
          floatingBannerNotification: null
        });
      }
    };
  });
};

exports.getWrappedFloatingBannerContainer = getWrappedFloatingBannerContainer;
var WrappedFloatingBannerContainer = getWrappedFloatingBannerContainer();
exports.WrappedFloatingBannerContainer = WrappedFloatingBannerContainer;

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloatingBannerBar = void 0;

var _primitive = __webpack_require__(117);

var _react = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _withDefaultStyles = __webpack_require__(36);

var _accessibilityHelper = __webpack_require__(163);

var _types = __webpack_require__(871);

var _styles = __webpack_require__(879);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

// We have this Wrapper because currently in CMUI we might shown fallback callout for some link
// Once there's no need to do that, we could move this part into UnstyledFloatingBanner
var DefaultWrapper =
/** @class */
function (_super) {
  __extends(DefaultWrapper, _super);

  function DefaultWrapper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DefaultWrapper.prototype.render = function () {
    return _react.default.isValidElement(this.props.notification.message) ? _react.default.createElement("span", {
      className: this.props.messageClassName,
      role: 'alert'
    }, this.props.notification.message) : _react.default.createElement("span", {
      className: this.props.messageClassName,
      dangerouslySetInnerHTML: {
        __html: this.props.notification.message
      },
      role: 'alert'
    });
  };

  return DefaultWrapper;
}(_react.default.PureComponent);

var UnstyledFloatingBannerBar =
/** @class */
function (_super) {
  __extends(UnstyledFloatingBannerBar, _super);

  function UnstyledFloatingBannerBar(props) {
    return _super.call(this, props) || this;
  }

  UnstyledFloatingBannerBar.prototype.render = function () {
    var _a = this.props,
        classes = _a.classes,
        notification = _a.notification,
        i18n = _a.i18n,
        dismiss = _a.dismiss,
        Wrapper = _a.Wrapper;

    var wrappedMsg = _react.default.createElement(Wrapper, {
      notification: notification,
      messageClassName: classes.text,
      i18n: i18n
    });

    var ExitIcon = _react.default.createElement(_primitive.Glyphicon, {
      className: (0, _classnames.default)('exitIcon', classes.exitIcon),
      glyph: 'ba-Cancel',
      onClick: function onClick() {
        return dismiss();
      },
      role: 'button',
      tabIndex: 0,
      "aria-label": i18n.getString(_TL_("Dismiss the message")),
      onKeyDown: (0, _accessibilityHelper.submitEvent)(dismiss)
    });

    if (notification.severity === _types.NotificationLevel.Info) {
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('floating-banner', 'infoFloatingBanner', classes.infoFloatingBanner)
      }, _react.default.createElement(_primitive.Glyphicon, {
        className: classes.infoIcon,
        glyph: 'ba-Completed'
      }), wrappedMsg, ExitIcon);
    } else if (notification.severity === _types.NotificationLevel.Warning) {
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('floating-banner', 'warnFloatingBanner', classes.warnFloatingBanner)
      }, _react.default.createElement(_primitive.Glyphicon, {
        className: classes.warnIcon,
        glyph: 'ba-Warning'
      }), wrappedMsg, ExitIcon);
    } else {
      return null;
    }
  };

  UnstyledFloatingBannerBar.defaultProps = {
    Wrapper: DefaultWrapper
  };
  return UnstyledFloatingBannerBar;
}(_react.default.PureComponent);

var FloatingBannerBar = (0, _withDefaultStyles.withDefaultStyles)(UnstyledFloatingBannerBar, _styles.styles);
exports.FloatingBannerBar = FloatingBannerBar;

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    infoFloatingBanner: {
      background: '#DFF6DD',
      position: 'fixed',
      bottom: '15%',
      left: '50%',
      right: '50%',
      boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.1)',
      width: 528,
      marginLeft: '-264px',
      display: 'flex',
      zIndex: 1100000
    },
    infoIcon: {
      color: '#107C10',
      fontSize: '16px !important',
      padding: '16px 8px 16px 8px',
      float: 'left'
    },
    exitIcon: {
      fontSize: '16px  !important',
      color: '#605E5C',
      padding: '16px 14px 16px 14px',
      float: 'right',
      cursor: 'pointer'
    },
    warnFloatingBanner: {
      background: '#FFF4CE',
      position: 'fixed',
      bottom: '15%',
      left: '50%',
      right: '50%',
      boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.1)',
      width: 528,
      marginLeft: '-264px',
      display: 'flex',
      zIndex: 1100000
    },
    warnIcon: {
      color: '#D83B01',
      fontSize: '16px !important',
      padding: '16px 8px 16px 8px',
      float: 'left'
    },
    text: {
      wordWrap: 'break-word',
      width: '456px',
      flex: 1,
      fontSize: 12,
      lineHeight: '16px',
      padding: '16px 0px 16px 0px'
    }
  };
};

exports.styles = styles;

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _oldAlertCenterAdapter = __webpack_require__(881);

Object.keys(_oldAlertCenterAdapter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _oldAlertCenterAdapter[key];
    }
  });
});

var _notificationApi = __webpack_require__(882);

Object.keys(_notificationApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _notificationApi[key];
    }
  });
});

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oldAlertCenterAdapter = exports.OldAlertCenterAdapter = void 0;

var _types = __webpack_require__(871);

var _notificationStore = __webpack_require__(868);

var OldAlertCenterAdapter =
/** @class */
function () {
  function OldAlertCenterAdapter() {}

  OldAlertCenterAdapter.prototype.show = function (alert) {
    // Transform level,
    // - Info in old Alert is Info
    // - Info in UNQ is Information.........
    var level;

    if (!alert.level || alert.level === 'Info' || alert.level === _types.NotificationLevel.Confirmation || alert.level === _types.NotificationLevel.Info) {
      level = _types.NotificationLevel.Info;
    } else {
      level = _types.NotificationLevel.Warning;
    }

    return _notificationStore.notificationStore.setFloatingBannerNotification(alert.message, level);
  };

  OldAlertCenterAdapter.prototype.dismiss = function (id) {
    _notificationStore.notificationStore.dismiss(id);
  };

  OldAlertCenterAdapter.prototype.dismissAll = function () {
    throw new Error('Not implemented');
  };

  OldAlertCenterAdapter.prototype.toastError = function (message) {
    return this.toastWarning(message);
  };

  OldAlertCenterAdapter.prototype.toastWarning = function (message) {
    return _notificationStore.notificationStore.setFloatingBannerNotification(message, _types.NotificationLevel.Warning);
  };

  OldAlertCenterAdapter.prototype.toastInfo = function (message) {
    return _notificationStore.notificationStore.setFloatingBannerNotification(message, _types.NotificationLevel.Info);
  };

  OldAlertCenterAdapter.prototype.toastConfirmation = function (message) {
    return this.showInfo(message);
  };

  OldAlertCenterAdapter.prototype.showError = function (message, id) {
    return this.toastWarning(message);
  };

  OldAlertCenterAdapter.prototype.showWarning = function (message, id) {
    return this.toastWarning(message);
  };

  OldAlertCenterAdapter.prototype.showInfo = function (message, id) {
    return this.toastInfo(message);
  };

  OldAlertCenterAdapter.prototype.showConfirmation = function (message, id) {
    return this.toastConfirmation(message);
  };

  return OldAlertCenterAdapter;
}();

exports.OldAlertCenterAdapter = OldAlertCenterAdapter;
// (window as any).App.views.alertCenter =
var oldAlertCenterAdapter = new OldAlertCenterAdapter(); // Put it here only for debugging purpose

exports.oldAlertCenterAdapter = oldAlertCenterAdapter;
window.oldAlertCenterAdapter = oldAlertCenterAdapter;
window.notificationStore = _notificationStore.notificationStore;

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationApi = exports.NotificationApi = void 0;

var _types = __webpack_require__(871);

var _notificationStore = __webpack_require__(868);

var NotificationApi =
/** @class */
function () {
  function NotificationApi() {}

  NotificationApi.prototype.dismiss = function (id) {
    _notificationStore.notificationStore.dismiss(id);
  };

  NotificationApi.prototype.showWarning = function (message, extraOptions) {
    return _notificationStore.notificationStore.setFloatingBannerNotification(message, _types.NotificationLevel.Warning, extraOptions);
  };

  NotificationApi.prototype.showInfo = function (message, extraOptions) {
    return _notificationStore.notificationStore.setFloatingBannerNotification(message, _types.NotificationLevel.Info, extraOptions);
  };

  NotificationApi.prototype.add = function (notification) {
    return _notificationStore.notificationStore.add(notification);
  };

  NotificationApi.prototype.removeAllTopBanners = function () {
    return _notificationStore.notificationStore.removeAllTopBanners();
  };

  return NotificationApi;
}();

exports.NotificationApi = NotificationApi;
var notificationApi = new NotificationApi(); // Put it here only for debugging purpose

exports.notificationApi = notificationApi;
window.notificationApi = notificationApi;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ })

/******/ })});;
